/** @jsx CanvaSX */
import type SelectField from '../../../fields/SelectField';
import { CanvaSX } from '@lib/canvasx/canvasx';
import { Rect } from '@lib/canvasx/components/Rect';
import { Text } from '@lib/canvasx/components/Text';
import { type FieldCanvaSXFactory } from './types';

export const SelectFieldCanvaSX: FieldCanvaSXFactory = (
  field: SelectField,
  object,
  value,
  maxChildWidth
) => {
  const option = field.options.findById(value);

  if (option) {
    const key = `field:${field.id}`;
    const hovering = object.hoveredKey === key;

    if (field.tags) {
      return (
        <Rect
          border={option.color}
          fill={hovering ? option.color : `${option.color}88`}
          borderRadius={10}
          padding={{ horizontal: 4, vertical: 2 }}
        >
          <Text size={8} maxWidth={maxChildWidth} overflow='…'>
            {option.name}
          </Text>
        </Rect>
      );
    } else {
      return (
        <Rect padding={2}>
          <Text size={8} maxWidth={maxChildWidth} overflow='…'>
            {option.name}
          </Text>
        </Rect>
      );
    }
  }
};
